<template>
  <div>
    <b-card border-variant="danger" v-if="errore_caricamento">
      <b-row class="match-height">
        <b-col
          md="8"
        >
          <h4 class="mt-0 mb-0 text-danger">Errore durante il caricamento delle informazioni iniziali</h4>
          <p>Ti preghiamo di segnalare il problema all'assistenza tecnica, grazie</p>
        </b-col>
        <b-col 
          md="4"
          class="text-center"
        >
          <b-button
          variant="primary"
          :to="{ name: 'home-agentscout' }"
          >
              <feather-icon
                  icon="CornerUpLeftIcon"
                  size="16"
                  class="mr-1"
              />Home
          </b-button>
        </b-col>
      </b-row>
        
    </b-card>
        
    <div class="text-center my-3" v-if="Caricato == false">
      <b-spinner  v-if="errore_caricamento == false"
          variant="primary"
          style="width: 3rem; height: 3rem;"
          label="loading"
      />
      <div class="pt-1 text-primary" style="display:block;">Caricamento</div>
    </div>

    <b-card bg-variant="Default" v-if="Caricato">
      <div class="text-right">
        <b-button variant="outline-primary" class="px-1 mb-1" @click.prevent="clickReset" v-if="resetState != 'hidden'"><feather-icon icon="DeleteIcon" /></b-button>
      </div>

        <!-- table -->
        <vue-good-table
        mode="remote"
        ref="table"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :rows="rows"
        :columns="columns"
        :isLoading=isLoading
        :search-options="{ 
            enabled: true,
            externalQuery: searchTerm }"
        :pagination-options="{
            enabled: true,
            perPage:pageLength
        }"
        >
        
        <template slot="loadingContent">
          <div class="text-center my-3">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem;"
                label="loading"
              />
              <div class="d-block pt-1 text-primary">Caricamento</div>
          </div>
        </template>
        
        <div slot="emptystate"> <div class="text-center py-4"> Nessun dato disponibile - (Messaggio personalizzabile) </div> </div>

        <template
            slot="table-row"
            slot-scope="props"
        >

            <!-- company_name -->
            <div v-if="props.column.field === 'customer.billing.company_name'">
            <a @click="$router.push({ name: 'crm-customers-show', params: { id_riga: props.row.customer.id }})">{{ props.row.customer.billing.company_name }}</a>   
            </div>

            <span v-else-if="props.column.field === 'totale'">
              {{ prezzoFormattato(props.formattedRow[props.column.field]) }}
            </span>

            <span v-else-if="props.column.field === 'stato'">
              <b-badge :variant="statoVariant(props.row.stato)">
                {{ props.row.stato }}
                </b-badge>
            </span>

            <span v-else-if="props.column.field === 'xml'">
              <b-badge :variant="xmlVariant(props.row.xml)">
                {{ props.row.xml }}
              </b-badge>
            </span>

            <!-- Column: bonifico -->
            <span v-else-if="props.column.field === 'bonifico'">
              {{ prezzoFormattato(props.formattedRow[props.column.field]) }}
            </span>

            <div v-else-if="props.column.field === 'stripetransaction.data'">
              <span v-if="props.row.stripetransaction">{{ formattazioneDataOra(props.row.stripetransaction.data, 'it', 'DD/MM/YYYY') }}</span>
              <span v-else>-</span>
            </div>

            <!-- Column: azioni -->
            <span v-else-if="props.column.field === 'azioni'">
              <div class="text-nowrap">
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="cursor-pointer text-secondary"
                  v-b-tooltip.hover.v-primary
                  title="Azioni"
                  :id="`tabellautenti-riga-${props.row.id}-sidebar-azioni`"
                  @click="sidebarAction(props.row.id, props.row.stato, props.row.license, props.row.numero, props.row.data, props.row.url_pdf, props.row.customer.billing.company_name, props.row.customer.billing.vat_scheme_id, props.row.xml,props.row.stripetransaction)"
                />
              </div>
            </span>

            <!-- Column: standard -->
            <span v-else>
            {{ props.formattedRow[props.column.field] }}
            </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
            <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                Visualizzazione da 1 a 
                </span>
                <b-form-select
                v-model="pageLength"
                :options="['10','25','50','100']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap "> di {{ props.total }} righe </span>
            </div>
            <div>
                <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
                >
                <template #prev-text>
                    <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                    />
                </template>
                <template #next-text>
                    <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                    />
                </template>
                </b-pagination>
            </div>
            </div>
        </template>
        </vue-good-table>
            
    </b-card>

    <b-sidebar
      ref="sidebar_azioni"
      id="sidebar-right"
      bg-variant="white"
      :title="infoSideBar.titolo"
      right
      backdrop
      shadow
    >
      <div>
        <div class="py-0 px-2">
          
          <div class="divider">
              <div class="divider-text text-primary fw-bolder">DETTAGLIO</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">XML:</span> <b-badge :variant="xmlVariant(infoSideBar.xml)">{{ infoSideBar.xml }}</b-badge>
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Stato:</span> <b-badge :variant="statoVariant(infoSideBar.status_name)">{{ infoSideBar.status_name }}</b-badge>
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Numero:</span> {{ infoSideBar.fic_numero }}
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Importo:</span> {{ prezzoFormattatoConIva(infoSideBar.license_data.price, infoSideBar.schema_iva) }}
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Emissione:</span> {{ infoSideBar.fic_data }}
            </b-col>
          </b-row>

          <!--
          <div class="divider">
            <div class="divider-text text-primary fw-bolder mt-0">PAGAMENTO</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold">Stripe payment_intent:</span> license_payment_log.api_payment_intent
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold">Stripe invoice:</span> license_payment_log.api_payment_intent.api_invoice
            </b-col>
          </b-row>
          -->

          <div class="divider">
            <div class="divider-text text-primary fw-bolder mt-0">BONIFICO</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Importo:</span> 
              <span v-if="infoSideBar.stripetransaction && infoSideBar.stripetransaction.bonifico">{{ formattazionePrezzoFloat(infoSideBar.stripetransaction.bonifico) }}</span>
              <span v-else>-</span>
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Incasso:</span> 
              <span v-if="infoSideBar.stripetransaction">{{ formattazioneDataOra(infoSideBar.stripetransaction.data, 'it', 'DD/MM/YYYY') }}</span>
              <span v-else>-</span>
            </b-col>
          </b-row>

          <div class="divider">
            <div class="divider-text text-primary fw-bolder mt-0">LICENZA</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Licenza:</span> {{ infoSideBar.license_data.ref_code }}
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Tipo:</span> <b-badge :variant="statusVariantTipo(infoSideBar.license_data.type)">{{ infoSideBar.license_data.type }}</b-badge>
            </b-col>
          </b-row>

          <div class="divider">
            <div class="divider-text text-primary fw-bolder mt-2">AZIONI</div>
          </div>
          
          <b-button
            v-if="infoSideBar.fic_url_pdf !== null"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary" block
            class="mb-1"
            target="_blank"
            :href="infoSideBar.fic_url_pdf"
          >
            <feather-icon icon="FileTextIcon" /> Scarica Fattura
          </b-button>
        </div>

      </div>
    </b-sidebar>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BCardText, BRow, BCol, BBadge, BPagination, BSpinner, BFormGroup, BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BDropdownDivider, BFormSelect, BDropdown, BDropdownItem, BButton, BSidebar, BAlert, VBToggle, VBTooltip
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import { prezzoFormattatoConIva, prezzoFormattato } from '@core/utils/funzioniGlobali' 

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BCard, 
    BCardText,
    BRow, 
    BCol, 
    BBadge,
    BPagination,
    BSpinner,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BDropdownDivider,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BButton, 
    BAlert ,
  },
  setup() {
      return {
        prezzoFormattatoConIva, 
        prezzoFormattato, 
      }
  },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      isLoading: true,
      emptystate: true, 
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Cliente',
          field: 'customer.billing.company_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Licenza',
          field: 'license.ref_code',
          width: '120px',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'XML',
          field: 'xml',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
            filterDropdownItems: [
                { value: 'Creata', text: 'Creata' },  
                { value: 'Inviata', text: 'Inviata' },  
                { value: 'Scartata', text: 'Scartata' },
                { value: 'Accettata', text: 'Accettata' },
            ],
          },
        },    
        {
          label: 'Stato',
          field: 'stato',
          width: '140px',
          html: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
            filterDropdownItems: [
                { value: 'Da Emettere', text: 'Da Emettere' },  
                { value: 'Da Pagare', text: 'Da Pagare' },  
                { value: 'In Pagamento', text: 'In Pagamento' },
                { value: 'Pagata', text: 'Pagata' },
                { value: 'Insoluta', text: 'Insoluta' },
                { value: 'Stornata', text: 'Stornata' },
            ],
          },
        },
        {
          label: 'Numero',
          field: 'numero',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Importo',
          field: 'totale',
          width: '100px',
          tdClass: 'text-right',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Emissione',
          field: 'data',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Incasso',
          field: 'stripetransaction.data',
          width: '100px',
          sortable: false,
          filterOptions: {
            enabled: false,
            placeholder: 'Filtra',
          },
        },

        {
          label: '',
          field: 'azioni',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
      rows: [],
      searchTerm: '',
      resetState: 'hidden',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      startServerParams: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      options_ricerca: [
        { value: null, text: 'seleziona...' },
        { value: 'customer.billing.company_name', text: 'Ragione Sociale' },
        { value: 'numero', text: 'Numero Fattura' },
      ],
      campiRicerca: {
        nome: '',
        sezione: null,
      },
      infoSideBar: {
        id: '',
        status_name: '',
        license_data: [ ],
        fic_numero: '',
        fic_data: '',
        fic_url_pdf: null,
        fic_invio_email_copia_cortesia: false,
        titolo: '', 
        schema_iva: 0, 
        xml: '', 
        stripetransaction: [], 
      },
      Caricato: false,
      errore_caricamento: false,

      ricerca_bonifico: true,
      ricerca_bonifico_dati: {
        payout_id: '',
        amount: '-',
        arrival_date: '-',
      },
    }
  },
  computed: {
    statoVariant() {
      const statusColor = {
        'Da Emettere'    : 'light-info',
        'Da Pagare' : 'light-danger',
        'In Pagamento' : 'light-warning',
        'Pagata' : 'light-success',
        'Insoluta' : 'light-danger',
        'Stornata' : 'light-secondary',
      }

      return status => statusColor[status]
    },
    xmlVariant() {
      const statusColor = {
        'Creata'    : 'light-info',
        'Inviata' : 'light-warning',
        'Scartata' : 'light-danger',
        'Accettata' : 'light-success',
      }

      return status => statusColor[status]
    },
    statusVariantTipo() {
      const statusColor = {
        'Abbonamento' : 'light-info',
        'OneShot' : 'light-secondary',
      }

      return status => statusColor[status]
    },
  },
  mounted() {
    //in caso di resize del browser -> ricalcolo della larghezza della finestra
    window.onresize = () => {
      this.checkWindowsSizeAndResponsiveGoodTable();
    }
  },
  created() {
    this.checkWindowsSizeAndResponsiveGoodTable();
    
    //adesso faccio il caricamento dei dati
    this.loadItems();

    this.Caricato = true;
    this.errore_caricamento = false;
  },
  methods: {
    checkWindowsSizeAndResponsiveGoodTable(){
      if(window.innerWidth <768){
        this.$set(this.columns[1], 'hidden', true)
        this.$set(this.columns[2], 'hidden', true)
        this.$set(this.columns[3], 'hidden', true)
        this.$set(this.columns[4], 'hidden', true)
        this.$set(this.columns[6], 'hidden', true)
        this.$set(this.columns[7], 'hidden', true)
      } else if(window.innerWidth <1000){
        this.$set(this.columns[1], 'hidden', true)
        this.$set(this.columns[2], 'hidden', true)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', true)
        this.$set(this.columns[7], 'hidden', true)
      } else if(window.innerWidth <1200){
        this.$set(this.columns[1], 'hidden', true)
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', true)
        this.$set(this.columns[7], 'hidden', true)
      } else if(window.innerWidth <1400){
        this.$set(this.columns[1], 'hidden', false)
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', false)
        this.$set(this.columns[7], 'hidden', false)
      } else {
        //tutte le colonne visualizzate
        this.$set(this.columns[1], 'hidden', false)
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', false)
        this.$set(this.columns[7], 'hidden', false)
      }
    },
    formattazioneDataOra(converted_at,lang,formato) {
      if (converted_at) {
        return moment(String(converted_at)).locale(lang).format(formato)
      } else {
        return '---'
      }
    },
    formattazionePrezzoFloat(prezzo) {
        // Converte il valore in stringa se non lo è già
        prezzo = prezzo.toString();
        
        // Verifica che la stringa contenga solo cifre
        if (!/^\d+$/.test(prezzo)) {
            return "---";
        }
        
        // Determina la parte intera e decimale
        let length = prezzo.length;
        let breakPoint = length - 2;
        let prezzoIntero = prezzo.slice(0, breakPoint);
        let prezzoDecimali = prezzo.slice(breakPoint);
        
        // Format del numero con separatori
        let prezzoElaborato = prezzoIntero + "," + prezzoDecimali;
        return prezzoElaborato.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
    },
    ricercaGenerale(){
      //console.log("ricerca generale - chiamata Api per avere la ricerca su tutti i dati e NON solo sui dati dell'attuale viewport della tabella ;-)")
      console.log(this.campiRicerca)

      if((this.campiRicerca.sezione !== null) && (this.campiRicerca.sezione !== 'undefined')){
        console.log("ok ricerca valida")

        //aggiorna parametri con la stessa funzione del filtro colonna ;-)
        this.updateParams({
          columnFilters: {
            [this.campiRicerca.sezione]: this.campiRicerca.nome
          },
        });

        //forza reset filtro colonne
        this.$refs.table.reset();

        this.loadItems();

        //attiva bottone "reset"
        this.resetState = 'attiva';
      }
    },
    clickReset(){
      console.log("clickReset");

      //forza reset filtro colonne
      this.$refs.table.reset();

      //forza reset parametri iniziali della tabella
      this.updateParams(this.startServerParams);
      this.loadItems();

      //reset campi ricerca
      this.campiRicerca.nome = '';
      this.campiRicerca.sezione = null;
      //disattiva bottone "reset"
      this.resetState = 'hidden';
    },
    advanceFilter(val) {
      //this.searchTerm = val

      this.updateParams(val);
      this.loadItems();
    },
    sidebarAction(id, status_name, license_data, fic_numero, fic_data, fic_url_pdf, titolo, schema_iva, xml, stripetransaction) {
      //console.log(fic_url_pdf);
      
      this.infoSideBar = { id: id,
        status_name: status_name,
        license_data: license_data,
        fic_numero: fic_numero,
        fic_data: fic_data,
        fic_url_pdf: fic_url_pdf, 
        titolo: titolo,
        schema_iva: schema_iva, 
        xml: xml, 
        stripetransaction: stripetransaction, };

      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    
    updateParams(newProps) {
      //console.log(newProps)

      if (typeof newProps.columnFilters !== 'undefined'){
        if(typeof newProps.columnFilters.aggregato_name_surname !== 'undefined'){
          //in caso di campo con "stringa" => vai di filtro per il valore richiesto
          if(newProps.columnFilters.aggregato_name_surname != ''){
            newProps.columnFilters['user.surname'] = newProps.columnFilters.aggregato_name_surname;
          }

          //in caso di campo in cui avevo impostato un filtro e lo voglio cancellare
          if(newProps.columnFilters.aggregato_name_surname == ''){
            delete(newProps.columnFilters['user.surname']);
          }
        }

      }

      //attiva bottone "reset" filtro o ricerca
      this.resetState = 'attiva';

      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      //console.log('cambio ordinamento')
      //console.log(params)

      let field_ricerca = '';

      //colonne con relazione
      if(params[0].field == 'source.text'){
        field_ricerca = 'source.name';
      } else if(params[0].field == 'aggregato_name_surname'){
        field_ricerca = 'user.surname';
      } else {
        field_ricerca = params[0].field;
      }

      this.updateParams({
        sort: [{
          type: params[0].type,
          field: field_ricerca,
        }],
      });
      this.loadItems();
    },
    
    onColumnFilter(params) {
      //console.log("AGGIORNAMENTO FILTRO COLONNA --------")
      this.updateParams(params);
      this.loadItems();
    },

    loadItems() {
      this.isLoading = true;

      this.$http.get('api/crm/invoice-fic/list', {
        params: this.serverParams 
        }).then(response => { 
            if(response.data.statusCode == 200){
              //ok
              this.totalRecords = response.data.reply.meta.total;
              this.rows = response.data.reply.data;
              
            } else if(response.data.statusCode == 422){
              //errori con testo di notifica ok dall'api
              this.$swal({
                title: 'Errore',
                text: 'codice errore: '+response.data.reply,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
            } else {
              //tutto gli altri possibili errori
              this.$swal({
                title: 'Errore Generico',
                text: 'codice errore: '+response.data.statusCode,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
            }
            
            //rimuovi il loading dopo il caricamento dei dati nella tabella
            this.isLoading = false;
        
        })

    },

    
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.riga_sidebar{
  padding-bottom: 5px;
}
.spacer-dettagli{
  width: 90px;
  display: inline-block;
}
</style>